export default "__VITE_ASSET__DkH6iFHU__"